import BX24 from './bx24';

export { BX24 };
